import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetPoisWithinRadius'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetPoisWithinRadiusStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetPoisWithinRadiusStore",
			variables: true,
		})
	}
}

export async function load_GetPoisWithinRadius(params) {
  await initClient()

	const store = new GetPoisWithinRadiusStore()

	await store.fetch(params)

	return {
		GetPoisWithinRadius: store,
	}
}
